import React, { FC } from 'react';
import Text from 'components/Text';
import '../BuyerObsFieldModal/styles.scss';

const BuyerObsFieldModal: FC<any> = ({ item }: any) => {

	return (
		<div className="buyerObsFieldModal-container">
			{item.notes === undefined ?
				<div className='undefinedNote'>
					<Text>
						Sem observações do cliente.
					</Text>
				</div>
				:
				<textarea
					value={item.notes}
					name="obsField"
					placeholder=""
					id=""
					maxLength={4000}
					cols={30}
					rows={10}
				>
				</textarea>}


		</div>
	);

};

export default BuyerObsFieldModal;